import { Container, Title, Text, Button, Flex, rem } from '@mantine/core';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getLinearGradient } from '../../../mantineTheme';
import logo from '../../../assets/full_logo2.svg';

export function AnimatedHero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <Container size="lg">
      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Flex direction="column" align="center" justify="center" ta="center">
          <motion.div variants={itemVariants}>
            <img src={logo} alt="Collabish Logo" style={{ width: rem(400), marginBottom: rem(20) }} />
          </motion.div>
          <motion.div variants={itemVariants}>
            <Title
              order={1}
              style={{
                fontSize: rem(60),
                fontWeight: 900,
                letterSpacing: '-1px',
              }}
            >
              Connect with Brands, Create & Earn
            </Title>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Text
              size="xl"
              mt="xl"
              style={{ maxWidth: 600, color: 'var(--mantine-color-gray-7)' }}
            >
              Collabish is the ultimate platform for creators to monetize their
              influence and for brands to find the perfect voice for their products.
            </Text>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Text size="lg" mt="xl" fw={700} style={{ color: 'var(--mantine-color-primary-6)' }}>
              Over $100,000 earned by creators already!
            </Text>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Flex gap="md" mt="xl">
                <Button 
                    component={Link} 
                    to="/creator-ai-assistant"
                    size="lg" 
                    radius="xl" 
                    style={{ background: getLinearGradient('primary') }}
                >
                    I'm a Creator
                </Button>
                <Button 
                    component={Link} 
                    to="/brand-dashboard"
                    size="lg" 
                    radius="xl" 
                    variant='outline' 
                    color='primary'
                >
                    I'm a Brand
                </Button>
            </Flex>
          </motion.div>
        </Flex>
      </motion.div>
    </Container>
  );
}